module.exports = __webpack_public_path__ + "static/konrad-2232a4fa33443d3ba419004a28844898.jpg";